import axios from 'axios';

function log(...args) {
  if (import.meta.env.DEV) {
    console.log('[API]', ...args);
  }
}

// ✅ Ottimizzazione: usa token cached, fallback con refresh se necessario
export function getToken(forceRefresh = false) {
  const user = window.firebase.auth().currentUser;
  if (!user) return Promise.reject('User not authenticated');
  return user.getIdToken(forceRefresh);
}

// ✅ Funzione interna comune per GET e POST, con retry su 401
function handleRequest(method, url, dataOrParams) {
  return new Promise((resolve, reject) => {
    const user = window.firebase.auth().currentUser;
    if (!user) {
      log('❌ No user logged in');
      return reject('User not authenticated');
    }

    const baseUrl = import.meta.env.VITE_BASE_URL + '/api';
    //const baseUrl = 'http://localhost:5000/mytransport-246817/us-central1/api';

    const callAxios = (token, retry = false) => {
      const headers = { Authorization: `Bearer ${token}` };
      const fullUrl = baseUrl + url;

      const config = {
        method,
        url: fullUrl,
        headers,
        ...(method === 'get' ? { params: dataOrParams } : { data: dataOrParams }),
      };

      /*             log(`➡️ ${method.toUpperCase()} ${fullUrl}`, method === 'get' ? dataOrParams : config.data);
                        log('🔐 Token:', token.slice(0, 10) + '...'); */

      axios(config)
        .then((response) => {
          const res = response.data;
          /* log(`✅ Response from ${url}:`, res); */
          if (response.status >= 200 && response.status < 300 && res.success) {
            resolve(res.data);
          } else {
            reject(res.message || 'Request failed');
          }
        })
        .catch((err) => {
          if (err.response) {
            log(
              `❌ Error ${err.response.status} on ${method.toUpperCase()} ${url}`,
              err.response.data
            );
            if (err.response.status === 401 && !retry) {
              // Token scaduto → forza refresh
              log('🔄 Token expired, refreshing...');
              user
                .getIdToken(true)
                .then((newToken) => callAxios(newToken, true))
                .catch((refreshErr) => {
                  log('❌ Token refresh failed', refreshErr);
                  /*                                     window.firebase.auth().signOut();
                                    window.location.href = '/login'; */
                  reject(refreshErr);
                });
            } else {
              /*                             if (err.response.status === 401) {
                                // Se anche il retry fallisce, forza il logout per forzare re-login pulito
                                log('❌ Persistent 401, forcing logout...');
                                window.firebase.auth().signOut();
                                window.location.href = '/login';
                            }
                            // Catturiamo per evitare l'uncaught promise nel console */
              reject(err);
            }
          } else {
            log('❌ Network or config error', err.message);
            reject(err);
          }
        });
    };

    // Primo tentativo con token cached
    user
      .getIdToken()
      .then((token) => callAxios(token))
      .catch((err) => {
        log('❌ Failed to get token', err);
        reject(err);
      });
  });
}

// ✅ API: GET request
export function doGet(url, params) {
  return handleRequest('get', url, params);
}

// ✅ API: POST request
export function doPost(url, data) {
  return handleRequest('post', url, data);
}

// ✅ API: DELETE request
export function doDelete(url) {
  return handleRequest('delete', url);
}
